import { render, staticRenderFns } from "./winner.vue?vue&type=template&id=dc173910&scoped=true&"
import script from "./winner.vue?vue&type=script&lang=js&"
export * from "./winner.vue?vue&type=script&lang=js&"
import style0 from "./winner.vue?vue&type=style&index=0&id=dc173910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc173910",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
